import { Dialog } from "@headlessui/react";
import { yupResolver } from "@hookform/resolvers/yup";
import { useEffect } from "react";
import { useForm } from "react-hook-form";
import { FormBox, ModalFoterBox } from "../../../components/box/Box";
import Button from "../../../components/button/Button";
import FormController from "../../../components/fields/FormController";
import { Modal, ModalProp } from "../../../components/modal/Modal";
import { LinkMenus, linkMenusSchema } from "../../../model/LinkMenus";
import { RadioButton } from "../../../components/radiobutton/RadioButton";
import { useInput } from "../../../hooks/useInput";

export type LinkMenusModalProp = {
  linkMenus?: LinkMenus;
  authorEmail: string;
  onSubmit: (data: LinkMenus) => Promise<void>;
}

export const LinkMenusModal = ({
  open,
  toggle,
  onSubmit,
  closeOnClickOutside,
  updateFlg,
  linkMenus,
  authorEmail,
}: ModalProp & LinkMenusModalProp) => {
  const { control, handleSubmit, reset, setValue } =
    useForm<LinkMenus>({
      resolver: yupResolver(linkMenusSchema),
      defaultValues: linkMenus,
    });

  const selectNumgerItems = [
    {id: "Web", title: "Web"},
    {id: "App", title: "アプリ"}
  ];

  const selectType = useInput("Web");

  useEffect(() => {
    setValue('id', linkMenus?.id ?? '');
    setValue('type', linkMenus?.type ?? 'Web');
    setValue('name', linkMenus?.name ?? '');
    setValue('packageName', linkMenus?.packageName ?? '');
    setValue('bundleID', linkMenus?.bundleID ?? '');
    setValue('url', linkMenus?.url ?? 'https://');
    setValue('createType', linkMenus?.createType);
    setValue('createUser', linkMenus?.createUser ?? authorEmail);
    setValue('createAt', linkMenus?.createAt ?? new Date());
    selectType.setValue(linkMenus?.type ?? 'Web');
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[linkMenus, setValue, updateFlg, authorEmail]);

  useEffect(() => {
    setValue('type', selectType.value);
  },[setValue, selectType.value]);

  useEffect(() => {
    if(!open) {
      reset();
      selectType.setValue(linkMenus?.type ?? 'Web');
      setValue('url', linkMenus?.url ?? 'https://');
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[linkMenus?.type, linkMenus?.url, open, reset, setValue]);

  return (
    <>
      <Modal
        open={open}
        toggle={toggle}
        closeOnClickOutside={closeOnClickOutside}
      >
        <Dialog.Panel className=" relative transform overflow-hidden rounded-lg bg-white  text-left shadow-xl transition-all sm:w-full max-w-screen-md ">
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="px-2 pb-4 sm:p-4">
              <div className="text-center sm:mt-3">
                <Dialog.Title
                  as="h3"
                  className="text-left text-lg font-medium leading-6 text-gray-900"
                >
                  連携アプリ{updateFlg ? "編集" : "登録"}
                </Dialog.Title>
                <div className="overflow-y-auto">
                  <div className="px-2 text-left pb-8 h-[500px] ">
                    <FormBox className="flex">
                      <RadioButton
                        children={undefined}
                        name={"type"}
                        label={"種別"}
                        value={selectType}
                        radioButtonItem={selectNumgerItems}
                        vertical />
                    </FormBox>
                    <FormBox className="flex">
                      <FormController
                        control={control}
                        name={"name"}
                        label={"表示名"}
                        type={"textarea"}
                        required
                      />
                      <div className="text-sm text-gray-700 mt-5">入力できる行数は3行以下、1行につき10文字以下です</div>
                    </FormBox><br/><br/>
                    <FormController
                      control={control}
                      name={"url"}
                      label={"URL"}
                      type={"text"}
                      required
                    />
                  </div>
                </div>
              </div>
            </div>
            <ModalFoterBox>
              <Button
                className="mx-2 mt-1 w-[132px]"
                outline
                onClick={toggle}
                children={"キャンセル"}
              />
              <Button
                className="mt-1 mr-2 w-[132px]"
                submit
                children={"登録"}
              />
            </ModalFoterBox>
          </form>
        </Dialog.Panel>
      </Modal>
    </>
  )
}